export default "<a href=\"{{$ctrl.yt_url}}\" target=\"_blank\"><img ng-src=\"{{$ctrl.icon_img}}\" style=\"height:20px;margin:{{$ctrl.margins}};\" /></a>";